import { AutoComplete as AutoCompleteA, type AutoCompleteProps } from 'antd';
import cn from 'classnames';
import styles from './auto-complete.module.css';

export type AutoCompleteProperties<ValueType> = {
  fullWidth?: boolean;
} & AutoCompleteProps<ValueType>;

const AutoComplete = <ValueType,>({ classNames, fullWidth, ...props }: AutoCompleteProperties<ValueType>) => (
  <AutoCompleteA<ValueType>
    className={cn({
      [styles['full-width'] ?? '']: fullWidth,
    })}
    classNames={
      typeof classNames === 'function'
        ? (info) => {
            const resolvedClassNames = classNames(info);

            return {
              ...resolvedClassNames,
              popup: {
                root: cn(resolvedClassNames?.popup, styles.popup),
              },
            };
          }
        : {
            ...classNames,
            popup: {
              root: cn(classNames?.popup, styles.popup),
            },
          }
    }
    size="large"
    {...props}
  />
);

export default AutoComplete;
